export default "__VITE_ASSET__a14f3004__"